<template>
	<div>
		<template v-if="appraisalLoadError">
			<h2>{{ appraisalLoadError }}</h2>
		</template>
		<template v-else-if="loadingAppraisal">
			<v-flex style="display: flex;">
				<v-progress-circular
					indeterminate
					color="primary"
					size="80"
					style="margin: auto;"
				/>
			</v-flex>
		</template>
		<template v-else-if="appraisal">
			<h2 class="ps__subtitle color--white">
				{{ $t('buyout.find_price_of_device') }}
			</h2>
			<div
				id="deviceCategories"
				class="green__wrapper buyout__deviceState"
				v-if="qualities"
			>
				<div
					id="deviceState"
					class="col buyout__deviceStateItem  buyout__worthItem"
					v-for="quality in qualities"
					:key="quality.id"
					:class="{
						active: qualitySelected && qualitySelected.id === quality.id
					}"
					@click="selectQuality(quality)"
					:data-bosscode="quality.product_code"
				>
					<div class="device-state">
						<div class="wrapper">
							<div class="title--quality category color--white">
								{{ quality.device_state_name }}
								<slot
									name="toolTipSlot"
									:text="quality.device_state_long_description"
								>
									<v-tooltip bottom>
										<template v-slot:activator="{ on }">
											<v-icon color="default" v-on="on">
												mdi-information-variant
											</v-icon>
										</template>
										<span>{{ quality.device_state_long_description }}</span>
									</v-tooltip>
								</slot>
							</div>
							<div class="state semibold color--white">
								{{ quality.device_state_description }}
							</div>
							<div
								class="description stateInfo text-center color--white"
								v-html="quality.device_state_short_description"
							>
								{{ quality.device_state_short_description }}
							</div>
						</div>
						<div class="priceWrapper desc">
							<div class="title--price price semibold">
								{{ $t('buyout.buyout_price') }}
							</div>
							<div
								class="price"
								v-if="quality.price || (!quality.price && quality.price === 0)"
							>
								{{ $n(quality.price, "currency") }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { VUEX_BUYOUT } from '../../../store/buyout';
import { config } from '../../../config/buyout';
import { sleep } from '../../../../js/buyout';
import SanitizeMixin from '../../../mixins/buyout/sanitize';
import { MUTATION_TYPES } from '../../../store/buyout/_mutation-types';
import { ACTION_TYPES } from '../../../store/buyout/_action-types';
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';
import {GETTER_TYPES} from "../../../store/buyout/_getter-types";
import {EventBus} from "../../../event_bus";

export default {
	name: 'DeviceState',
	props: {
		deviceFormsOffset: {
			type: Number,
			default: 0,
			required: false
		}
	},
	data() {
		return {
			show: false
		}
	},
	mixins: [SanitizeMixin],
	async created() {
		if (this.campaign && !this.campaign.autoload_bonus)
			await this[ACTION_TYPES.GET_BUYOUT_BONUSES]();
			await this[ACTION_TYPES.LOAD_APPRAISAL]();
			if (config.scrollToElements) {
						await sleep(200);
						this.$scrollTo('#deviceState', {offset:-300,duration: 400});
					}
	},
	computed: {
		...mapState(VUEX_BUYOUT.NAMESPACE,[
			'loadingAppraisal',
			'appraisal',
			'qualities',
			'appraisalLoadError',
			'selectedCategory',
			'campaign',
			'isRegistration'
		]),
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.SELECTED_QUALITY
		]),
		currency() {
			return this.$sanitize(config.currency);
		},
		qualitySelected: {
			get() {
				return this[GETTER_TYPES.SELECTED_QUALITY];
			},
			set(v) {
				this[MUTATION_TYPES.SET_SELECTED_QUALITY](v);
			}
		},
	},
	methods: {
		...mapMutations(VUEX_BUYOUT.NAMESPACE, [
			MUTATION_TYPES.SET_DEFAULT_QUALITY_CONDITIONS,
			MUTATION_TYPES.SET_SELECTED_QUALITY
		]),
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.GET_BUYOUT_BONUSES,
			ACTION_TYPES.LOAD_APPRAISAL
		]),
		async selectQuality(quality) {
			if (!this.isRegistration) return;

			this[MUTATION_TYPES.SET_DEFAULT_QUALITY_CONDITIONS](
				quality.default_device_condition_choices
			);
			EventBus.$emit('updateAppraisalConditions');
			await sleep(10);
			this.qualitySelected = quality;

			if (config.scrollToElements) {
				await sleep(350);
				this.$scrollTo('#deviceForms', {
					offset: this.deviceFormsOffset,
					duration: 500,
				});
			}
		}
	}
}
</script>
